import Swiper from 'swiper/bundle';
const initSliders = () => {

    new Swiper('.news-swiper', {
        preventClicksPropagation: true,
        slidesPerView: 1.5,
        spaceBetween: 0,
        slidesPerColumn: 1,
        slidesPerColumnFill: 'row',
        loop: false,
        centeredSlides: true,
        preloadImages: false,
        navigation: {
            nextEl: '.swiper-button-next-unique',
            prevEl: '.swiper-button-prev-unique',
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                loop: true,
            },
        },
    });

    new Swiper('.services-swiper', {
        preventClicksPropagation: true,
        slidesPerView: 1,
        spaceBetween: 20,
        slidesPerColumn: 1,
        slidesPerColumnFill: 'row',
        loop: false,
        centeredSlides: true,
        preloadImages: false,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        // navigation: {
        //     nextEl: '.swiper-button-next',
        //     prevEl: '.swiper-button-prev',
        // },
    });
};

export { initSliders };


// WEBPACK FOOTER //
// ./scripts/sliders.js